export default {
    name: '礼品',
    url: '/admin/gift', // rest接口表名
    query: '&sort=sort', // rest接口query参数
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '序号', dataIndex: 'sort'},
            {title: '礼品名称', dataIndex: 'name'},
            {title: '图片', dataIndex: 'img', customRender: text => text ? <div class="photo-img"><img src={text} /></div> : '无'},
        ]
    },
    // 列表查询表单
    queryForm: [
        {
            key: 'name',
            label: '',
            component: 'a-input',
            props: {
                placeholder: '请输入礼品名称搜索',
            },
        },
    ],
    // 新增/编辑查询表单
    items: [
        {
            key: 'name',
            label: '礼品名称',
            component: 'a-input',
            props: {
                placeholder: '请输入礼品名称',
            },
            rules: [{ required: true, message: '请输入礼品名称', trigger: 'blur' }]
        },
        {
            key: 'info',
            label: '礼品介绍',
            component: 'a-textarea',
            props: {
                placeholder: '请输入',
                autoSize: { minRows: 4, maxRows: 8 }
            },
            style: {
                width: '100%'
            },
            rules: [{ required: true, message: '请输入礼品介绍', trigger: 'blur' }]
        },
        {
            key: 'img',
            label: '礼品图片',
            component: 'form-upload',
            props: {
                limit: 9,
                size: 10 * 1024,
                tip: "最多上传9张，图片大小不超过10M"
            },
            rules: [{ required: true, message: '请上传礼品图片', trigger: 'change' }]
        },
        {
            key: 'sort',
            label: '序号',
            component: 'a-input-number',
            props: {
                placeholder: '数字越小，排位越前',
            },
            style: {
                width: '100%'
            },
            rules: [{ required: true, message: '请输入序号', trigger: 'blur' }]
        },
    ],
    // 详情接口expand字段
    expand: '',
    init: {}, // 新增实体初始化字段
    // 详情渲染字段
    renderItems: (ctx) => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement;
        const res = [
            {
                label: '礼品名称',
                key: 'name',
            },
            {
                label: '礼品介绍',
                key: 'info',
                textarea: true
            },
            {
                label: '礼品图片',
                key: 'img',
                img: true
            },
            {
                label: '序号',
                key: 'sort',
            },
        ];
        return res;
    },
}
